(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aryveda-botanical-landing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('abl-landing')) {
    class AblLanding extends HTMLElement {
      constructor() {
        super();

        this.links = Array.from(this.querySelectorAll('.abl-sidenav__link'));
        this.entries = this.links
          .map((link) => {
            const target = document.getElementById(link.dataset.ablTarget);
            return target ? { link, target } : null;
          })
          .filter(Boolean);

        this.links.forEach((link) => {
          link.addEventListener('click', this.onLinkClick.bind(this));
        });

        if (this.entries.length === 0) return;

        this.observer = new IntersectionObserver(this.onIntersection.bind(this), {
          rootMargin: '-40% 0px -40% 0px',
          threshold: 0,
        });

        this.entries.forEach(({ target }) => this.observer.observe(target));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      onIntersection(observedEntries) {
        observedEntries.forEach((observedEntry) => {
          const match = this.entries.find(({ target }) => target === observedEntry.target);
          if (!match) return;
          match.link.classList.toggle('is-active', observedEntry.isIntersecting);
        });
      }

      onLinkClick(event) {
        const link = event.currentTarget;
        const target = document.getElementById(link.dataset.ablTarget);
        if (!target) return;

        event.preventDefault();

        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
          block: 'start',
        });
      }
    }

    customElements.define('abl-landing', AblLanding);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aryveda-offer-bar"]) return;
  try {
    
  if (!customElements.get('aryveda-offer-bar')) {
    const DAY_MS = 86400000;

    // "+0530" / "-0500" -> minutes. Falls back to UTC so a countdown still
    // runs to a single shared deadline rather than disappearing.
    function parseUtcOffset(value) {
      const match = /^([+-])(\d{2})(\d{2})$/.exec((value || '').trim());
      if (!match) return 0;
      const minutes = Number(match[2]) * 60 + Number(match[3]);
      return match[1] === '-' ? -minutes : minutes;
    }

    // "23:59" -> minutes past midnight. Falls back to midnight.
    function parseClock(value) {
      const match = /^(\d{1,2}):(\d{2})$/.exec((value || '').trim());
      if (!match) return 0;
      const hours = Number(match[1]);
      const minutes = Number(match[2]);
      if (hours > 23 || minutes > 59) return 0;
      return hours * 60 + minutes;
    }

    class AryvedaOfferBar extends HTMLElement {
      connectedCallback() {
        this.fields = {
          days: this.querySelector('[data-offer-days]'),
          hours: this.querySelector('[data-offer-hours]'),
          minutes: this.querySelector('[data-offer-minutes]'),
          seconds: this.querySelector('[data-offer-seconds]'),
        };
        if (!this.fields.seconds) return;

        this.isDaily = this.dataset.mode === 'daily';

        if (this.isDaily) {
          this.offsetMs = parseUtcOffset(this.dataset.utcOffset) * 60000;
          this.resetMs = parseClock(this.dataset.reset) * 60000;
          this.end = this.nextReset();
        } else {
          const end = Number(this.dataset.end) * 1000;
          if (!Number.isFinite(end) || end <= 0) return;
          this.end = end;
          this.hideExpired = this.dataset.hideExpired === 'true';
        }

        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        if (this.timer) clearInterval(this.timer);
      }

      // Next occurrence of the reset time, anchored to the store's timezone so
      // every visitor counts down to the same moment.
      nextReset() {
        const storeNow = Date.now() + this.offsetMs;
        let boundary = Math.floor(storeNow / DAY_MS) * DAY_MS + this.resetMs;
        if (boundary <= storeNow) boundary += DAY_MS;
        return boundary - this.offsetMs;
      }

      tick() {
        let remaining = Math.floor((this.end - Date.now()) / 1000);

        if (remaining <= 0) {
          if (this.isDaily) {
            this.end = this.nextReset();
            remaining = Math.floor((this.end - Date.now()) / 1000);
          } else {
            remaining = 0;
            if (this.timer) clearInterval(this.timer);
            if (this.hideExpired) {
              this.hidden = true;
              return;
            }
          }
        }

        // Without a days unit (daily mode) the hours roll up to the full span
        // rather than being truncated at 24.
        const hasDays = Boolean(this.fields.days);
        const days = hasDays ? Math.floor(remaining / 86400) : 0;
        const hours = hasDays
          ? Math.floor((remaining % 86400) / 3600)
          : Math.floor(remaining / 3600);
        const minutes = Math.floor((remaining % 3600) / 60);
        const seconds = remaining % 60;

        if (hasDays) {
          this.fields.days.textContent = String(days).padStart(2, '0');
        }
        this.fields.hours.textContent = String(hours).padStart(2, '0');
        this.fields.minutes.textContent = String(minutes).padStart(2, '0');
        this.fields.seconds.textContent = String(seconds).padStart(2, '0');
      }
    }

    customElements.define('aryveda-offer-bar', AryvedaOfferBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ashwagandha-landing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('al-landing')) {
    class AlLanding extends HTMLElement {
      constructor() {
        super();

        this.links = Array.from(this.querySelectorAll('.al-sidenav__link'));
        this.entries = this.links
          .map((link) => {
            const target = document.getElementById(link.dataset.alTarget);
            return target ? { link, target } : null;
          })
          .filter(Boolean);

        this.links.forEach((link) => {
          link.addEventListener('click', this.onLinkClick.bind(this));
        });

        if (this.entries.length === 0) return;

        this.observer = new IntersectionObserver(this.onIntersection.bind(this), {
          rootMargin: '-40% 0px -40% 0px',
          threshold: 0,
        });

        this.entries.forEach(({ target }) => this.observer.observe(target));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      onIntersection(observedEntries) {
        observedEntries.forEach((observedEntry) => {
          const match = this.entries.find(({ target }) => target === observedEntry.target);
          if (!match) return;
          match.link.classList.toggle('is-active', observedEntry.isIntersecting);
        });
      }

      onLinkClick(event) {
        const link = event.currentTarget;
        const target = document.getElementById(link.dataset.alTarget);
        if (!target) return;

        event.preventDefault();

        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
          block: 'start',
        });
      }
    }

    customElements.define('al-landing', AlLanding);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["badges-carousel"] && !Shopify.designMode) return;
  try {
    
  class TrustBadgesSplide {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('.trust-badges-splide__viewport');
      this.splide = null;
      this.mql = window.matchMedia('(max-width: 1024px)');
      this.onChange = this.onChange.bind(this);
      this.mql.addEventListener('change', this.onChange);
      this.tryMount();
    }

    tryMount() {
      if (!this.mql.matches) return;

      if (typeof window.Splide === 'undefined') {
        window.addEventListener('splide:loaded', () => this.tryMount(), { once: true });
        return;
      }

      this.mount();
    }

    mount() {
      if (this.splide || !this.track) return;

      this.splide = new window.Splide(this.track, {
        type: 'loop',
        perPage: 2,
        perMove: 1,
        gap: '1.6rem',
        pagination: true,
        arrows: true,
        autoplay: this.root.dataset.autoplay === 'true',
        interval: Number(this.root.dataset.autoplaySpeed) || 4000,
        pauseOnHover: true,
        breakpoints: {
          768: {
            perPage: 1,
          },
        },
      });

      this.splide.mount();
    }

    unmount() {
      if (this.splide) {
        this.splide.destroy(true);
        this.splide = null;
      }
    }

    onChange(event) {
      if (event.matches) {
        this.tryMount();
      } else {
        this.unmount();
      }
    }
  }

  function initTrustBadgesSplide() {
    document.querySelectorAll('[data-trust-badges-splide]').forEach((root) => {
      if (root.trustBadgesSplideInstance) return;
      root.trustBadgesSplideInstance = new TrustBadgesSplide(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTrustBadgesSplide);
  } else {
    initTrustBadgesSplide();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
